import React, { useState } from "react";
import Dashboard from "./components/Dashboard";
import SmsForm from "./components/smsForm";
import SmsConfig from "./components/SmsConfig";
import SmsTemplatePage from "./components/SmsTemplatePage";
import SmsSendPage from "./components/SmsSendPage";
import SchedulerControl from "./components/SchedulerControl";
import SMSReport from "./components/SMSReport";
import Login from "../src/components/Login/login";

import "./App.css";

function App() {
  const [activeMenu, setActiveMenu] = useState("dashboard"); // 👈 default landing page
  const [user, setUser] = useState(null);

  if (!user) {
    return <Login onLogin={setUser} />;
  }

  return (
    <div className="layout">
      <div className="sidebar">
        <div className="sidebar-title">SMS Console</div>

        <div className="user-info">
          <div className="user-avatar">
            {user.username?.charAt(0).toUpperCase()}
          </div>
          <div className="user-details">
            <span className="label">Signed in as</span>
            <span className="name">{user.username}</span>
          </div>
        </div>

        <div className="menu-list">
          <div
            className={`menu-item ${activeMenu === "dashboard" ? "active" : ""}`}
            onClick={() => setActiveMenu("dashboard")}
          >
            <span className="icon">🏠</span> Dashboard
          </div>

          <div
            className={`menu-item ${activeMenu === "sms" ? "active" : ""}`}
            onClick={() => setActiveMenu("sms")}
          >
            <span className="icon">✉️</span> SMS Form
          </div>

          <div
            className={`menu-item ${activeMenu === "list" ? "active" : ""}`}
            onClick={() => setActiveMenu("list")}
          >
            <span className="icon">⚙️</span> SMS Config List
          </div>

          <div
            className={`menu-item ${activeMenu === "template" ? "active" : ""}`}
            onClick={() => setActiveMenu("template")}
          >
            <span className="icon">📄</span> SMS Template
          </div>

          <div
            className={`menu-item ${activeMenu === "send" ? "active" : ""}`}
            onClick={() => setActiveMenu("send")}
          >
            <span className="icon">🚀</span> Send SMS
          </div>

          <div
            className={`menu-item ${activeMenu === "scheduler" ? "active" : ""}`}
            onClick={() => setActiveMenu("scheduler")}
          >
            <span className="icon">⏱️</span> Scheduler Control
          </div>

          <div
            className={`menu-item ${activeMenu === "report" ? "active" : ""}`}
            onClick={() => setActiveMenu("report")}
          >
            <span className="icon">📊</span> SMS Report
          </div>
        </div>

        <div className="menu-divider"></div>

        <div className="menu-item logout" onClick={() => setUser(null)}>
          <span className="icon">🚪</span> Logout
        </div>
      </div>

      <div className="content">
        {activeMenu === "dashboard" && <Dashboard user={user} />}
        {activeMenu === "sms" && <SmsForm />}
        {activeMenu === "list" && <SmsConfig />}
        {activeMenu === "template" && <SmsTemplatePage />}
        {activeMenu === "send" && <SmsSendPage />}
        {activeMenu === "scheduler" && <SchedulerControl />}
        {activeMenu === "report" && <SMSReport />}
      </div>
    </div>
  );
}

export default App;